import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/auth/AuthContext'
import { RequireAuth } from '@/auth/RequireAuth'
import { LecturerLayout } from '@/layouts/LecturerLayout'
import { StudentLayout } from '@/layouts/StudentLayout'
import { LoginPage } from '@/pages/LoginPage'
import { LecturerAssessmentsPage } from '@/pages/lecturer/LecturerAssessmentsPage'
import { LecturerAttendancePage } from '@/pages/lecturer/LecturerAttendancePage'
import { LecturerCoursesPage } from '@/pages/lecturer/LecturerCoursesPage'
import { LecturerDashboard } from '@/pages/lecturer/LecturerDashboard'
import { LecturerMaterialsPage } from '@/pages/lecturer/LecturerMaterialsPage'
import { StudentAssignmentsPage } from '@/pages/student/StudentAssignmentsPage'
import { StudentAttendancePage } from '@/pages/student/StudentAttendancePage'
import { StudentCoursesPage } from '@/pages/student/StudentCoursesPage'
import { StudentDashboard } from '@/pages/student/StudentDashboard'
import { StudentMaterialsPage } from '@/pages/student/StudentMaterialsPage'

function HomeRedirect() {
  const { user, loading } = useAuth()
  if (loading) return <div className="grid min-h-full place-items-center text-slate-500">Loading…</div>
  if (!user) return <Navigate to="/login" replace />
  return (
    <Navigate
      to={user.role === 'LECTURER' || user.role === 'SUPER_ADMIN' ? '/lecturer' : '/student'}
      replace
    />
  )
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<HomeRedirect />} />

        <Route element={<RequireAuth roles={['STUDENT']} />}>
          <Route path="/student" element={<StudentLayout />}>
            <Route index element={<StudentDashboard />} />
            <Route path="courses" element={<StudentCoursesPage />} />
            <Route path="attendance" element={<StudentAttendancePage />} />
            <Route path="materials" element={<StudentMaterialsPage />} />
            <Route path="assignments" element={<StudentAssignmentsPage />} />
          </Route>
        </Route>

        <Route element={<RequireAuth roles={['LECTURER', 'SUPER_ADMIN']} />}>
          <Route path="/lecturer" element={<LecturerLayout />}>
            <Route index element={<LecturerDashboard />} />
            <Route path="courses" element={<LecturerCoursesPage />} />
            <Route path="attendance" element={<LecturerAttendancePage />} />
            <Route path="materials" element={<LecturerMaterialsPage />} />
            <Route path="assessments" element={<LecturerAssessmentsPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}
